import { _WEB_VERSION } from './constant';
// export const _BASE_URL = 'http://localhost:8080'; // Stage
export const _BASE_URL = 'https://api.logohouse.art'; // Production

const Routes = {
    _ACCOUNT_LOGIN: '/account/login',
    _USER_REGISTER: '/account/register',
    _FORGOT_PASSWORD: '/account/forgot-password',
    _CHANGE_PASSWORD: '/account/change-password',
    _ACCOUNT_VERIFY: 'account/verify',
    _ACCOUNT_LOGOUT: '/account/logout',
    _ACCOUNT_IS_LOGGED_IN: '/account/is-logged-in',
    _TRANSACTION_INIT_CC: '/transaction/init-cc',
    _TRANSACTION_INIT: '/transaction/init',
    _TRANSACTION_DIRECT_CALLBACK: '/transaction/cc-callback',
    _PLACE_ORDER: '/order/place'
};

export default Routes;
